import { getFileName } from '@crema/utility/Utils';
import {
    GET_DRH,
    GET_DETAIL_DATA_DIRI,
    GET_DIKLAT_KURSUS_PEGAWAI,
    UPDATE_MANUAL_DATA_DRH_PEGAWAI,
    GET_LIST_BIDANG_KEAHLIAN_PEGAWAI,
    UPLOAD_ATTACHMENT_PEGAWAI_KEAHLIAN,
    UPDATE_ATTACHMENT_PEGAWAI_KEAHLIAN,
    GET_KELOMPOK_TALENTA,
    GET_PREDIKAT_EKINERJA,
    UPDATE_MANUAL_DOKUMEN_DRH_PEGAWAI,
    SET_PROGRESS_UPDATE_DRH,
    CLEAR_PROGRESS_UPDATE_DRH,
} from 'shared/constants/ActionTypes';

const INIT_STATE = {
    data: {
        result: null
    },
    detailData: null,
    bidangKeahlian: {
        data: null,
        attachments: []
    },
    diklatKursus: {
        results: []
    },
    // `type` menandai siapa pemilik task yang sedang berjalan ('data' | 'dokumen'),
    // supaya saat halaman dibuka ulang hanya tombol pemiliknya yang menyambung polling
    progressUpdate: {
        result: {
            task: '',
            type: ''
        }
    },
    kelompokTalenta: {
        results: [],
        table: []
    },
    predikatEkinerja: {
        results: []
    },
};

const drhReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DRH: {
            return {
                ...state,
                data: action.payload
            }
        }
        case GET_DETAIL_DATA_DIRI: {
            return {
                ...state,
                detailData: action.payload
            }
        }
        case GET_DIKLAT_KURSUS_PEGAWAI: {
            return {
                ...state,
                diklatKursus: action.payload
            }
        }
        case GET_LIST_BIDANG_KEAHLIAN_PEGAWAI: {
            return {
                ...state,
                bidangKeahlian: {
                    ...state.bidangKeahlian,
                    data: action.payload
                }
            }
        }
        case UPLOAD_ATTACHMENT_PEGAWAI_KEAHLIAN: {
            const fileObj = action.payload.result
            const tmpFile = {
                name: getFileName(fileObj.file),
                size: fileObj.file_size,
                type: fileObj.mime_type,
                file: fileObj.file,
                ...fileObj
            }

            return {
                ...state,
                bidangKeahlian: {
                    ...state.bidangKeahlian,
                    attachments: [...state.bidangKeahlian.attachments, tmpFile]
                }
            }
        }
        case UPDATE_ATTACHMENT_PEGAWAI_KEAHLIAN: {
            return {
                ...state,
                bidangKeahlian: {
                    ...state.bidangKeahlian,
                    attachments: action.payload
                }
            }
        }
        // payload polling menimpa progressUpdate, tapi `type` harus dipertahankan
        // karena hanya diisi saat klaim awal dan tidak ikut dikirim server
        case UPDATE_MANUAL_DATA_DRH_PEGAWAI:
        case UPDATE_MANUAL_DOKUMEN_DRH_PEGAWAI: {
            return {
                ...state,
                progressUpdate: {
                    ...action.payload,
                    result: {
                        ...action.payload?.result,
                        type: state.progressUpdate?.result?.type || ''
                    }
                }
            }
        }
        case SET_PROGRESS_UPDATE_DRH: {
            return {
                ...state,
                progressUpdate: {
                    ...state.progressUpdate,
                    result: {
                        ...state.progressUpdate?.result,
                        ...action.payload
                    }
                }
            }
        }
        case CLEAR_PROGRESS_UPDATE_DRH: {
            return {
                ...state,
                progressUpdate: {
                    result: {
                        task: '',
                        type: ''
                    }
                }
            }
        }
        case GET_KELOMPOK_TALENTA: {
            return {
                ...state,
                kelompokTalenta: action.payload,
                table: mapTableProfilTalenta(action.payload)
            }
        }
        case GET_PREDIKAT_EKINERJA: {
            return {
                ...state,
                predikatEkinerja: action.payload
            }
        }
        default:
            return state;
    }
};

const mapTableProfilTalenta = (datas) => {
    let results = []
    const apiResults = datas?.results
    if (apiResults.length === 0) results = []
    else {
        const { sumbu_x, sumbu_y, box, status_triwulan, tahun_triwulan } = apiResults[0]
        results = [
            {
                box,
                kinerja_x: `${sumbu_x[0]?.capaian}`,
                kompetensi: `${sumbu_x[1]?.capaian}`,
                potensi: `${sumbu_x[2]?.capaian}`,
                kualifikasi: `${sumbu_x[3]?.capaian}`,
                integritas_moralitas: `${sumbu_x[4]?.capaian}`,
                kinerja_y: `${sumbu_y[0]?.capaian}`,
                kinerja_utama: `${sumbu_y[1]?.capaian}`,
                kinerja_penguat: `${sumbu_y[2]?.capaian}`,
                status_triwulan,
                tahun_triwulan
            }
        ]
    }
    return results
}

export default drhReducer;
